var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAvatarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9 0a9 9 0 1 1-.001 18.001A9 9 0 0 1 9 0Zm0 3C7.343 3 6 4.399 6 6.52c0 1.485.736 3.332 1.692 4.306l-2.033.509a2.001 2.001 0 0 0-1.08.697l-.467.585a1.993 1.993 0 0 0-.41.954A6.983 6.983 0 0 0 9 16a6.982 6.982 0 0 0 5.298-2.429 1.992 1.992 0 0 0-.41-.954l-.466-.585a2.002 2.002 0 0 0-1.081-.697l-2.034-.509C11.263 9.852 12 8.006 12 6.52 12 4.399 10.657 3 9 3Z"
})));
export default SvgIconAvatarFilled;